import { Button, Grid, Stack } from '@mui/material';
import BackButton from './BackButton';
import CancelModal from '../Modal/CancelModal';
import DeleteReportModal from "../Modal/DeleteReportModal";
import {CustomizedDivider} from "../CustomStyles/StyledComponents";
import { useSelector } from 'react-redux';
import { ReportStatus } from '../../helpers/reportResultsHelper'
import { AGCReportsPermissions } from '../../helpers/permissionsHelper'



const DataEntryButtonStack = ({
    modalOpen,
    setModalOpen,
    handleModalResponse,
    handleSaveClick,
    handleNextClick, 
    handleDeleteModalResponse,
    setdeleteModalOpen,
    deleteModalOpen = false, 
    deleteDisabled = true,
    divider=true
}) => {

    const rptStatus = useSelector(state => state?.farmReport?.reportSettings?.status);
    const accessLevel = useSelector(state => state?.farmReport?.reportSettings?.accessLevel);
    const farmPermissions = useSelector(state => state.auth.farmPermissions);

    // if we can't save we cant delete either
    let saveDeleteDisabled = rptStatus && accessLevel?
                                  !ReportStatus.canEdit(rptStatus,accessLevel) 
                                : !AGCReportsPermissions.canCreate(farmPermissions)
    return (
        <>
        <Grid container direction="row" >
            <Grid item xs={4}>
                <BackButton />
            </Grid>
            <Grid item xs={4} sx={{ display:'flex', alignItems:'center' }}>
                {/* To be used in the future to show validation information during data entry */}
            </Grid>
            <Grid item xs={4} sx={{ display:'flex', alignItems:'center' }}>
                <Stack spacing={2} sx={{ marginLeft: 'auto', float: 'right' }} direction="row">
                    <Button
                        variant="outlined"
                        sx={{ textTransform: 'none' }}
                        onClick={() => setModalOpen(true)}
                        aria-label='Data Entry Cancel'>
                        Cancel
                    </Button>
                    {handleDeleteModalResponse && setdeleteModalOpen?
                        <Button 
                            disabled={deleteDisabled || saveDeleteDisabled}
                            variant="outlined" sx={{ textTransform: 'none' }}
                            onClick={(e) => { setdeleteModalOpen(true);}}
                            aria-label='Data Entry Delete Report'>
                            Delete
                        </Button>:''}
                    <Button variant="outlined"
                        disabled={saveDeleteDisabled}
                        sx={{ textTransform: 'none' }}
                        onClick={handleSaveClick}
                        aria-label='Data Entry Save Report'>
                        Save
                    </Button>
                    <Button variant="contained"
                        sx={{ textTransform: 'none' }}
                        className="activated"
                        onClick={handleNextClick}
                        aria-label='Data Entry Next Page'>
                        Next
                    </Button>
                </Stack>
            </Grid>
            <CancelModal isOpen={modalOpen} handleResponse={handleModalResponse} />
            <DeleteReportModal isOpen={deleteModalOpen} handleResponse={handleDeleteModalResponse} />
        </Grid>
        {divider?<CustomizedDivider/>:''}
        </>
    );
};

export default DataEntryButtonStack;

